import React from 'react';
import PropTypes from 'prop-types';
import '@fiverr/i18n/singleton';
import Input from '../../../../Input';
import { MIN_GIG_PRICE_RANGE, MAX_GIG_PRICE_RANGE } from '../../Filter/consts';
import './styles.scss';

const _rangeValue = (val) => parseInt(val, 10) || 0;
const parseRangeValue = ({ min, max }) => {
    const [minVal, maxVal] = [min, max].map((v) => _rangeValue(v));
    return { min: minVal, max: maxVal };
};

const Range = ({ value, id, currencySymbol, onChange }) => {
    const mapValues = {
        min: value[0] || MIN_GIG_PRICE_RANGE,
        max: value[1] || MAX_GIG_PRICE_RANGE
    };

    const onRangeChange = (key, val) => {
        if (Number.isNaN(val)) {
            return;
        }

        if (val < 0) {
            val = val * -1;
        }

        if (val > MAX_GIG_PRICE_RANGE) {
            val = MAX_GIG_PRICE_RANGE;
        }

        const change = { [key]: _rangeValue(val) };
        const newVal = {
            ...mapValues,
            ...change
        };
        onChange(id, [newVal.min, newVal.max]);
    };

    const { min, max } = parseRangeValue(mapValues);

    const DOMAttributes = {
        min: MIN_GIG_PRICE_RANGE,
        max: MAX_GIG_PRICE_RANGE
    };

    return (
        <div className="range">
            <Input type="number"
                name={id}
                className="input min"
                onChange={(e) => onRangeChange('min', e.target.value)}
                symbol={currencySymbol}
                {...DOMAttributes}
                value={(min && min !== MIN_GIG_PRICE_RANGE) ? min : ''}/>
            <span className="light">-</span>
            <Input type="number"
                name={id}
                className="input max"
                onChange={(e) => onRangeChange('max', e.target.value)}
                symbol={currencySymbol}
                {...DOMAttributes}
                value={(max && max !== MAX_GIG_PRICE_RANGE) ? max : ''}/>
        </div>
    );

};

Range.propTypes = {
    id: PropTypes.string.isRequired,
    currencySymbol: PropTypes.string.isRequired,
    options: PropTypes.array,
    onChange: PropTypes.func,
    onClear: PropTypes.func
};

Range.defaultProps = {
    value: [0, 0], // min, max
    onChange: () => true
};

export default Range;
